import flatten, { unflatten } from "flat";
import fp from "lodash/fp";

// Allows one match which is itself. If there more then throws
export const uniqueSsn = (value, allValues) => {
	let isSsnEntered =
		value &&
		fp.get("ownerPrincipalSection.signer.ssn", allValues) === value;
	const owners = fp.getOr([], "ownerPrincipalSection.owners", allValues);

	for (let owner of owners) {
		if (isSsnEntered && owner?.ssn === value) {
			return "Enter unique SSN";
		}
		if (isSsnEntered || owner.ssn) {
			isSsnEntered = isSsnEntered || owner.ssn === value;
		}
	}
};

export const totalSumLessThan100 = (_value, allValues) => {
	const profiles = [
		...(allValues.ownerPrincipalSection?.owners || []),
		allValues.ownerPrincipalSection?.signer,
	];

	return profiles.reduce((a, c) => a + parseFloat(c?.ownership || 0), 0) > 100
		? "Total sum of 100% is exceeded"
		: undefined;
};

export const asyncSsnFormValidationSettings = ({
	extraValidationActions,
	extraValidationFields = [],
} = {}) => ({
	asyncValidate: async (values, dispatch, props, blurredField) => {
		if (blurredField) {
			let err = {
				...props.formAsyncErrors,
			};

			if (extraValidationActions) {
				const extraErrors = await extraValidationActions(
					values,
					dispatch,
					props,
					blurredField,
				);
				err = {
					...err,
					...extraErrors,
				};
			}

			err = fp.flow(
				fp.defaults({}),
				flatten,
				fp.pickBy(fp.identity),
				fp.pickBy(value => !(fp.isObject(value) && fp.isEmpty(value))),
				unflatten,
			)(err);

			if (!fp.isEmpty(err)) throw err;
		}
	},
	asyncBlurFields: [...extraValidationFields],
});
